<div class="select">
  <select name="DmvState" (change)="StateChanged($event)" [value]="SelectedState">
    <option value="all">All</option>
    <option value="0">Missing</option>
    <option value="1">Processing</option>
    <option value="2">Fetched</option>
  </select>
</div>

